module.exports = __webpack_public_path__ + "static/media/T. Kenneth Escoe@2x.644d829c.jpg";